import {jenks} from 'simple-statistics'
export class SenseApplyRateLogic {
    constructor(monoChrome = false) {
        this.monoChrome = monoChrome
    }

    getColors() {
        if (this.monoChrome) {
            return [
                'rgb(209,209,255)',
                'rgb(190,190,255)',
                'rgb(171,171,255)',
                'rgb(152,152,255)',
                'rgb(133,133,255)',
                'rgb(114,114,255)',
                'rgb(95,95,255)',
                'rgb(76,76,255)',
                'rgb(57,57,255)',
                'rgb(38,38,255)',
                'rgb(0,0,255)',
            ]
        }

        return [
            '#800000',
            '#ff0000',
            '#ee6800',
            '#fbac00',
            '#fff300',
            '#a1ce00',
            '#5eb500',
            '#009b0e',
            '#005400',
            '#0a5191',
            '#04005c',
        ]
    }

    getSteps(data, rateProperty) {
        const d = data.features.map((f) => f.properties[rateProperty])
            .filter((n) => n > 0)
            .sort((a, b) => a - b)

        if (d.length === 0) {
            return [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
        }

        const epsilon = d[0] > 1 ? 5 : 0.5
        const q1 = d[Math.floor(d.length / 4)]
        const q3 = d[Math.floor(d.length * (3 / 4))]
        const irq = q3 - q1
        const lowerBound = q1 - (1.5 * irq)
        const upperBound = q3 + (1.5 * irq)
        const filteredData = d.filter(
            (d) => d >= lowerBound && d <= upperBound,
        ).map((d) => parseFloat(d.toFixed(0)))
        const uniqueKeys = filteredData.reduce((acc, curr) => {
            acc[curr] = true

            return acc
        }, {})
        const uniqueVals = Object.keys(uniqueKeys).map((k) => parseFloat(k))
        const jenk = jenks(filteredData, Math.min(9, uniqueVals.length))
        if (jenk.length > 2 && (jenk[jenk.length - 1] === jenk[jenk.length - 2])) {
            jenk.pop() // remove duplicate last value
        }
        const extendedJenk = this.ensurePadding(jenk, epsilon)

        return extendedJenk ? [0, epsilon, ...extendedJenk] : [-0.000011, -0.0001, -0.00009, -0.00008, -0.00007, -0.00006, -0.00005, -0.00004, -0.00003, -0.00002, 0]
    }

    ensurePadding(jenk, epsilon) {
        const extendedJenk = []
        // Add intermediate values to provide higher contrast when only 2 or 3 colors are used.
        if (jenk.length == 2) {
            jenk = [
                jenk[0] - epsilon,
                jenk[0],
                jenk[0] + ((jenk[1] - jenk[0]) / 3),
                jenk[0] + (2 * (jenk[1] - jenk[0]) / 3),
                jenk[1],
                jenk[1] + epsilon,
            ]
        }
        else if (jenk.length == 3) {
            jenk = [
                jenk[0] - epsilon,
                jenk[0],
                jenk[0] + ((jenk[1] - jenk[0]) / 2),
                jenk[1],
                jenk[1] + ((jenk[2] - jenk[1]) / 2),
                jenk[2],
                jenk[2] + epsilon,
            ]
        }

        // fill values on the bottom and top
        const bottomFill = Math.floor((8 - jenk.length) / 2)
        for (let i = 0; i < bottomFill; i++) {
            const fill = jenk[0] - (epsilon * (bottomFill - i))
            extendedJenk.push(fill)
        }

        extendedJenk.push(jenk[0])
        for (let i = 1; extendedJenk.length < 9; i++) {
            if (i < jenk.length && jenk[i] != extendedJenk[extendedJenk.length - 1]) {
                extendedJenk.push(jenk[i])
            }
            else {
                extendedJenk.push(extendedJenk[extendedJenk.length - 1] + epsilon)
            }
        }

        // prevent too small of changes
        for (let i = 1; i < extendedJenk.length - 1; i++) {
            if (extendedJenk[i + 1] - extendedJenk[i] < epsilon) {
                extendedJenk[i + 1] = extendedJenk[i] + epsilon
            }
        }

        return extendedJenk
    }
}
